import { EventEmitterImpl } from "./soft.js";
const EventEmitter = EventEmitterImpl;
const EventStrictTypeEmitter = EventEmitterImpl;
export {
  EventEmitter,
  EventStrictTypeEmitter
};
//# sourceMappingURL=index.js.map
